export default "__VITE_ASSET__kEFs8akH__"